//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {}
  },
  props: {
    item: {
      type: Object,
    },
    status: {
      type: Number,
    },
  },
  computed: {},
  methods: {
    viewData() {
      this.$emit('view', this.item)
    },
  },
}
